export default "__VITE_ASSET__CCEk5JIu__"